export default __webpack_public_path__ + "static/media/computer_click_icon.b1f52020.svg";